import React from "react";
import { Button } from "antd";
import { LinkedinOutlined } from "@ant-design/icons";
import { Company } from "../types";
import styles from "../styles/companies.module.css";

interface CompanyCardProps {
  companies: Company[];
}

const CompanyCard: React.FC<CompanyCardProps> = ({ companies }) => {
  return (
    <div className={styles.cardContainer}>
      {companies.map((company) => (
        <div key={company.key} className={styles.card}>
          <img
            src={company.logo}
            alt={`${company.name} Logo`}
            className={styles.cardLogo}
          />
          <div className={styles.cardContent}>
            <h3>{company.name}</h3>
            <p>{company.description}</p>

            {/* Funding Stage */}
            <p>
              <strong>Funding Stage:</strong> {company.fundingStage}
            </p>

            {/* New Location field */}
            <p>
              <strong>Location:</strong> {company.location}
            </p>

            {/* Employees */}
            <p>
              <strong>Employees:</strong> {company.employees}
            </p>

            {/* Primary Sector */}
            <p>
              <strong>Primary Sector:</strong> {company.primarySector}
            </p>

            {/* Website */}
            {company.website && (
              <p>
                <a
                  href={company.website}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {company.website}
                </a>
              </p>
            )}

            {/* LinkedIn */}
            {company.linkedin && (
              <p>
                <a
                  href={company.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginRight: "10px" }}
                >
                  <LinkedinOutlined style={{ fontSize: "20px" }} />
                </a>
              </p>
            )}

            {/* Hiring Button (Careers) */}
            {company.careers && (
              <Button
                type="primary"
                href={company.careers}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "#f42722",
                  color: "white",
                  border: "none",
                }}
              >
                Hiring
              </Button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CompanyCard;
